(() => {
  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  const getTemplate = (root, sectionId, handle) =>
    root.querySelector(`#compare-dual-tpl-${CSS.escape(sectionId)}-${CSS.escape(handle)}`);

  const swapCard = (root, sectionId, slot, handle) => {
    const tpl = getTemplate(root, sectionId, handle);
    if (!tpl) return;

    const card = qs(root, `[data-compare-card][data-slot="${slot}"]`);
    if (!card) return;

    card.replaceChildren(tpl.content.cloneNode(true));
  };

  const updateWarning = (root) => {
    const leftSel = qs(root, `[data-compare-select][data-slot="left"]`);
    const rightSel = qs(root, `[data-compare-select][data-slot="right"]`);
    const warning = qs(root, `[data-compare-warning]`);
    if (!leftSel || !rightSel || !warning) return;

    const isDuplicate = leftSel.value && rightSel.value && leftSel.value === rightSel.value;

    // No layout jump: keep element in flow and fade it
    warning.style.opacity = isDuplicate ? '1' : '0';
    warning.style.pointerEvents = isDuplicate ? 'auto' : 'none';
    warning.setAttribute('aria-hidden', isDuplicate ? 'false' : 'true');
  };

  const init = (root) => {
    const sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    // Ensure warning starts non-jumpy (in case CSS isn't loaded yet)
    const warning = qs(root, `[data-compare-warning]`);
    if (warning) {
      warning.style.opacity = warning.style.opacity || '0';
      warning.style.pointerEvents = 'none';
      warning.setAttribute('aria-hidden', 'true');
    }

    const onChange = (select) => {
      const slot = select.getAttribute('data-slot');
      const handle = select.value;

      swapCard(root, sectionId, slot, handle);
      updateWarning(root);
    };

    qsa(root, `[data-compare-select]`).forEach((select) => {
      select.addEventListener('change', () => onChange(select));
    });

    // Sync initial state
    const leftSel = qs(root, `[data-compare-select][data-slot="left"]`);
    const rightSel = qs(root, `[data-compare-select][data-slot="right"]`);

    if (leftSel?.value) swapCard(root, sectionId, 'left', leftSel.value);
    if (rightSel?.value) swapCard(root, sectionId, 'right', rightSel.value);
    updateWarning(root);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-compare-dual-root]').forEach(init);
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    event.target?.querySelectorAll?.('[data-compare-dual-root]').forEach(init);
  });
})();
